import {defineStore} from "pinia";

export const useAthleteStore = defineStore('athleteStore', {
    state: () => ({
        athletes: [] as any[],
    }),
    getters: {
        userAthletes: (state) => {
            const userStore = useUserStore()
            return state.athletes.filter(item => item?.client_id === userStore.userdata?.id)
        },
        athleteFromDatabase: (state) => {
            const userStore = useUserStore()
            return state.athletes.filter((item) => item?.client_id != userStore.userdata?.id)
        }
    },
    actions: {
        setAthletes(payload: any) {
            payload.forEach((athlete) => {
                if (!this.athletes.some((originalItem) => originalItem.id === athlete.id)) {
                    this.athletes.push(athlete);
                }
            });
        },
        addOrChangeAthlete(athlete) {
            const index = this.athletes.findIndex((item) => item.id === athlete.id);
            if (index > -1) {
                this.athletes[index] = athlete;
            } else {
                this.athletes.push(athlete);
            }
        },
        setDocuments(athlete_id, documents) {
            const index = this.athletes.findIndex((item) => item.id === athlete_id);
            if (index > -1) {
                this.athletes[index].documents = documents;
            }
        },
        addDocument(athlete_id: number, document: any) {
            const index = this.athletes.findIndex((item) => item.id === athlete_id);
            if (index > -1) {
                this.athletes[index].documents.push(document);
            }
        },
        removeDocument(athlete_id, document_id) {
            const index = this.athletes.findIndex((item) => item.id === athlete_id);
            if (index > -1) {
                this.athletes[index].documents = this.athletes[index].documents.filter((item) => item.id !== document_id);
            }
        },
        async createAthlete(payload: any) {
            let request = payload
            if(payload.avatar){
                request = getFormdata(request)
            }
            await fetchAuth('athletes', {
                method: 'POST',
                body: request
            }).then((response) => {
                this.addOrChangeAthlete(response)
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async updateAthlete(payload: any, athlete_id: number) {
            let request = {...payload}
            if(payload.avatar){
                request['_method'] = 'PUT';
                request = getFormdata(request)
            }
            await fetchAuth(`athletes/${athlete_id}`, {
                method: payload.avatar ? 'POST' : 'PUT',
                body: request
            }).then((response) => {
                this.addOrChangeAthlete(response)
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async getDocuments(athlete_id) {
            return await fetchAuth(`athletes/${athlete_id}/documents`)
                .then((response) => {
                    this.setDocuments(athlete_id, response)
                }).catch((e) => {
                    return Promise.reject(e);
                })
        },
        async fetchUploadDocument(athlete_id: number, payload: any) {
            const formData = new FormData()
            formData.append('dictionary_document_id', payload.dictionary_document_id)
            payload.attachments.forEach((attachment) => {
                formData.append('attachments[]', attachment)
            })
            
            await fetchAuth(`athletes/${athlete_id}/documents`, {
                method: 'POST',
                body: formData
            }).then((response) => {
                this.addDocument(athlete_id, response)
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async fetchDeleteDocument(athlete_id: number, document_id: number) {
            await fetchAuth(`athletes/${athlete_id}/documents/${document_id}`, {
                method: 'DELETE'
            }).then((response) => {
                this.removeDocument(athlete_id, document_id)
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async fetchSingleAthlete(athlete_id: number) {
            return await fetchData(`athletes/${athlete_id}`)
                .then((response) => {
                    return response;
                }).catch((e) => {
                    return Promise.reject(e);
                })
        },
        async getAthletesCardsWithDocuments(athlete_ids: number[]): Promise<any[]> {
            const athletes = this.athletes.filter((item) => athlete_ids.includes(item.id))
            if(athletes.length === athlete_ids.length){
                return athletes
            }
            
            const query = new URLSearchParams();
            athlete_ids.forEach((id, index) => {
                if(!id) return
                query.append(`ids[${index}]`, id.toString())
            });
            return await fetchAuth(`athletes/cards-with-documents?${query.toString()}`, {
                method: 'GET'
            })
            .then((response: any) => {
                this.setAthletes(response)
                return response
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async searchAthletes(search: string) {
            return await fetchData(`athletes/search`, {
                method: 'GET',
                query: {
                    search
                },
            })
            .then((response) => {
                return response;
            }).catch((e) => {
                return Promise.reject(e);
            })
        },
        async deleteAthlete(id){
            return await fetchAuth(`athletes/${id}`, {
                method: 'DELETE'
            }).then((response) => {
                this.athletes = this.athletes.filter((item) => item.id !== id);
            })
        }
    },
})